import * as apiGetDetails from 'api/shoppingCart/GetShoppingCartGetDetailsIdV1';
import * as Translation from 'types/_general/Translation';

export * as Ingredient from 'types/ShoppingCart/Ingredient';

export type Type = {
	id: string;
	name: Translation.Type<string>;
};

export function create(): Type {
	return {
		id: '',
		name: {},
	};
}

export function mapFromApi(input: apiGetDetails.ProductItems): Type {
	return {
		id: input.ingredientId,
		name: input.ingredientNameTranslation,
	};
}
